module.exports = __webpack_public_path__ + "static/media/4f_website_logo_sup_cityuhk.420a3446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4f_website_logo_sup_cityuhk.jpg
// module id = 59
// module chunks = 0